import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class GlobalEventsManager {

  private _sendEnableEditScopeDetails: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public sendEnableEditScopeDetailsEmitter: Observable<boolean> = this._sendEnableEditScopeDetails.asObservable();

  private _sendopenConfirmationModal: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public sendopenConfirmationModalEmitter: Observable<boolean> = this._sendopenConfirmationModal.asObservable();

  private _showNavBar: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public showNavBarEmitter: Observable<boolean> = this._showNavBar.asObservable();

  private _showNavBarSeller: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public showNavBarSellerEmitter: Observable<boolean> = this._showNavBarSeller.asObservable();

  private _showNavBarWorker: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public showNavBarWorkerEmitter: Observable<boolean> = this._showNavBarWorker.asObservable();

  private _showNavBarRoleName: BehaviorSubject<string> = new BehaviorSubject<string>('');
  public showNavBarRoleNameEmitter: Observable<string> = this._showNavBarRoleName.asObservable();

  private _sendUnreadMessageArray: BehaviorSubject<Array<any>> = new BehaviorSubject<Array<any>>([]);
  public sendUnreadMessageArrayEmitter: Observable<Array<any>> = this._sendUnreadMessageArray.asObservable();

  private _sendUnreadMessageCoworkerArray: BehaviorSubject<Array<any>> = new BehaviorSubject<Array<any>>([]);
  public sendUnreadMessageCoWorkerArrayEmitter: Observable<Array<any>> = this._sendUnreadMessageCoworkerArray.asObservable();

  // Notify Read --
  private _sendReadMessageArray: BehaviorSubject<Array<any>> = new BehaviorSubject<Array<any>>([]);
  public sendReadMessageArrayEmitter: Observable<Array<any>> = this._sendReadMessageArray.asObservable();

  private _sendReadMessageCoworkerArray: BehaviorSubject<Array<any>> = new BehaviorSubject<Array<any>>([]);
  public sendReadMessageCoWorkerArrayEmitter: Observable<Array<any>> = this._sendReadMessageCoworkerArray.asObservable();


  // Notification Identify
  private _sendNotificationSellerName: BehaviorSubject<string> = new BehaviorSubject<string>('');
  public sendNotificationSellerNameEmitter: Observable<string> = this._sendNotificationSellerName.asObservable();

  private _sendNotificationWorkerName: BehaviorSubject<string> = new BehaviorSubject<string>('');
  public sendNotificationWorkerNameEmitter: Observable<string> = this._sendNotificationWorkerName.asObservable();


  // Active Request Notification issue resolve
  private _sendActiveRequestProjectIdsArray: BehaviorSubject<Array<any>> = new BehaviorSubject<Array<any>>([]);
  public sendActiveRequestProjectIdArrayEmitter: Observable<Array<any>> = this._sendActiveRequestProjectIdsArray.asObservable();


  // Remove Browse request Notification
  private _showBrowseRequestNotification: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public showBrowseRequestNotificationEmitter: Observable<boolean> = this._showBrowseRequestNotification.asObservable();

  // Show Selected Header Indicator
  private _sendheaderActivate: BehaviorSubject<string> = new BehaviorSubject<string>(null);
  public sendHeaderActivateEmitter: Observable<string> = this._sendheaderActivate.asObservable();

  // Pass Project Internal Name
  private _sendEditedInternalName: BehaviorSubject<string> = new BehaviorSubject<string>(null);
  public sendInternalEditedNameEmitter: Observable<string> = this._sendEditedInternalName.asObservable();

  constructor() { }

  showNavBar(ifShow: boolean) {
    this._showNavBar.next(ifShow);
  }

  showNavBarSeller(ifShow: boolean) {
    this._showNavBarSeller.next(ifShow);
  }

  showNavBarWorker(ifShow: boolean) {
    this._showNavBarWorker.next(ifShow);
  }

  showNavBarRoleName(roleName: string) {
    this._showNavBarRoleName.next(roleName);
  }

  sendMessageArray(unreadMessage: Array<any>) {
    this._sendUnreadMessageArray.next(unreadMessage);
  }

  sendMessageArrayCoWorker(unreadMessage: Array<any>) {
    this._sendUnreadMessageCoworkerArray.next(unreadMessage);
  }

  sendMessageReadArray(unreadMessage: Array<any>) {
    this._sendReadMessageArray.next(unreadMessage);
  }

  sendMessageReadArrayCoWorker(unreadMessage: Array<any>) {
    this._sendReadMessageCoworkerArray.next(unreadMessage);
  }


  sendActiveRequestProjectIds(projectIds: Array<any>) {
    this._sendActiveRequestProjectIdsArray.next(projectIds);
  }

  sendNotificationWorkerName(roleName: string) {
    this._sendNotificationWorkerName.next(roleName);
  }

  sendNotificationSellerName(roleName: string) {
    this._sendNotificationSellerName.next(roleName);
  }

  sendEnableEditScopeDetails(isedit: boolean) {
    this._sendEnableEditScopeDetails.next(isedit);
  }

  sendopenConfirmationModal(isedit: boolean) {
    this._sendopenConfirmationModal.next(isedit);
  }

  showBrowseRequestNotification(ifShow: boolean) {
    this._showBrowseRequestNotification.next(ifShow);
  }

  sendHeaderActivate(header: string) {
    this._sendheaderActivate.next(header);
  }

  sendEditedInternalName(header: string) {
    this._sendEditedInternalName.next(header);
  }
}



// WEBPACK FOOTER //
// ./src/app/app-global-events-manager.ts